import React, { useState, useEffect } from "react";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableHead,
  TableRow,
  Grid,
  InputAdornment,
  IconButton,
  Typography,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";

export default function Table(props) {
  const {
    tblHead = [],
    tblData = [],
    FooterRow,
    hideHeader = false,
    showSearch = true,
    HeaderComp = <div></div>,
    ActionComp = <div></div>,
    onClick,
  } = props;
  const { t } = useTranslation();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [_tblData, _setTblData] = useState(tblData);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSerach = (e) => {
    _setTblData([
      ...tblData.filter((j) =>
        Object.keys(j).some((x) =>
          String(j[x]).toLowerCase().includes(e.target.value.toLowerCase())
        )
      ),
    ]);
  };

  useEffect(() => {
    _setTblData(tblData);
    return () => {};
  }, [tblData]);

  return (
    <>
      {!hideHeader && (
        <Box className="flex justify-between items-center flex-wrap mb-[15px] bg-white p-[5px] rounded-[18px] border !border-slate-100">
          <Box
            className="flex"
            sx={{
              minWidth: { xs: "100%", lg: "250px" },
              mb: { xs: "10px", lg: "0px" },
            }}
          >
            <HeaderComp />
          </Box>
          {showSearch && (
            <Grid sx={{ width: { xs: "100%", lg: "250px" } }}>
              <TextField
                name="search"
                placeholder={t("search")}
                size="small"
                onChange={handleSerach}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton size="small" sx={{ p: "5px" }}>
                        <SearchRoundedIcon size="inherit" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          )}
        </Box>
      )}

      {/* Table  */}
      <div className="w-full overflow-hidden bg-white rounded-[15px] border !border-slate-200">
        <TableContainer sx={{ maxHeight: "calc(100vh - 184px)" }}>
          <MuiTable stickyHeader>
            <TableHead>
              <TableRow>
                {tblHead.map((item, i) => (
                  <TableCell
                    key={i}
                    sx={{
                      fontSize: "12px",
                      fontWeight: "600",
                      letterSpacing: "0.04em",
                      backgroundColor: "var(--white-color)",
                      color: "var(--primary-color)",
                      borderBottom: "1px solid var(--primaryMD-color)",
                      minWidth: "80px",
                      textTransform: "uppercase",
                      padding: "10px 10px 10px 14px",
                    }}
                  >
                    {item.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {_tblData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, i) => {
                  return (
                    <TableRow
                      onClick={() => {
                        onClick && onClick(item);
                      }}
                      hover
                      key={i}
                      sx={{
                        "&:hover": {
                          cursor: "pointer",
                        },
                      }}
                    >
                      {tblHead.map((headItem, index) => {
                        return (
                          <TableCell
                            key={index}
                            sx={{
                              fontSize: "16px",
                              padding: "6px 16px 6px 16px",
                              whiteSpace: "nowrap",
                              color: "var(--gray-color)",
                            }}
                          >
                            {headItem.id === "actions" ? (
                              <ActionComp {...item} />
                            ) : (
                              item[headItem.id]
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              <TableRow>{FooterRow && <FooterRow />}</TableRow>
            </TableBody>
          </MuiTable>
          {_tblData.length <= 0 && (
            <Typography
              variant="h6"
              className="tx-center p-30 tx-upp gray-color"
            >
              {t("dataNotAvailable")}
            </Typography>
          )}
        </TableContainer>
        {_tblData.length > 0 && (
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            labelRowsPerPage={t("rows")}
            count={_tblData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              "& .MuiToolbar-root": {
                minHeight: "40px",
                padding: "0 8px",
              },
              "& .MuiTablePagination-displayedRows": {
                fontSize: "0.875rem",
                color: "gray",
              },
              "& .MuiTablePagination-selectLabel": {
                fontSize: "0.875rem",
                fontWeight: 500,
                color: "#333",
              },
              // Dropdown (rows per page) styling
              "& .MuiTablePagination-select": {
                fontSize: "0.875rem",
                padding: "4px 8px",
                borderRadius: "4px",
                backgroundColor: "var(--primaryXS-color)",
                "&:hover": {
                  backgroundColor: "var(--primaryXS-color)",
                },
              },
              // Navigation buttons (prev/next)
              "& .MuiTablePagination-actions": {
                marginLeft: "8px",
                "& .MuiIconButton-root": {
                  padding: "4px",
                  color: "var(--primary-color)",
                  "&:hover": {
                    backgroundColor: "var(--primaryXS-color)",
                  },
                  "&.Mui-disabled": {
                    color: "#bdbdbd",
                  },
                },
              },
            }}
          />
        )}
      </div>
    </>
  );
}
